import { LocalSelectionType } from '@modules/reservations/create/models'

export const localSelectionOptions = [
  { label: 'Wybór automatyczny (bezpłatny)', value: LocalSelectionType.FREE },
  { label: 'Płatny wybór lokalu', value: LocalSelectionType.PAYABLE },
]
